// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-ejercicio{
    box-shadow: 0 0 1px rgba(0, 0, 0, .125), 0 1px 3px rgba(0, 0, 0, .2);
    border-radius: .25rem;
    background-color: #fff;
    display: flex;
    margin-bottom: 1rem;
    /* min-height: 80px; */
    /* padding: .5rem; */
    position: relative;
    width: 100%;
}
.info-box-text{
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    font-weight: 600;
}
.img-info-ejercicio img{
    margin: 5px;
    border-radius: .25rem;
}
.tags-info{
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.info-series{
    background: #efefef;
    padding: 5px;
    border-radius: 5px;
}
.comentarios-cliente{
    background: #efefef;
    padding: 5px;
    min-height: 100px;
    border-radius: 5px;
}
.cards-ejercicios{
    display: flex;
    overflow-x: scroll;
}
.tarjeta-ejercicio{
    cursor: pointer;
}

.activo{
    background: #c26a6a;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/trainer-dashboard/programas/config-avanzada/registro-ejercicios/registro-ejercicios.component.css"],"names":[],"mappings":"AAAA;IACI,oEAAoE;IACpE,qBAAqB;IACrB,sBAAsB;IAEtB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".info-ejercicio{\n    box-shadow: 0 0 1px rgba(0, 0, 0, .125), 0 1px 3px rgba(0, 0, 0, .2);\n    border-radius: .25rem;\n    background-color: #fff;\n    display: -ms-flexbox;\n    display: flex;\n    margin-bottom: 1rem;\n    /* min-height: 80px; */\n    /* padding: .5rem; */\n    position: relative;\n    width: 100%;\n}\n.info-box-text{\n    display: block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: 12px;\n    font-weight: 600;\n}\n.img-info-ejercicio img{\n    margin: 5px;\n    border-radius: .25rem;\n}\n.tags-info{\n    display: block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.info-series{\n    background: #efefef;\n    padding: 5px;\n    border-radius: 5px;\n}\n.comentarios-cliente{\n    background: #efefef;\n    padding: 5px;\n    min-height: 100px;\n    border-radius: 5px;\n}\n.cards-ejercicios{\n    display: flex;\n    overflow-x: scroll;\n}\n.tarjeta-ejercicio{\n    cursor: pointer;\n}\n\n.activo{\n    background: #c26a6a;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
